import { EdgeInterfaceDto, IPAssignemntDto } from '../../dto/gateway-dto';
import GatewayDto from '../../dto/gateway-dto';
export function getGatewayInterfaceListingDatatableConfig() {
    return {
        dom: 'Bfrtip',
        columns: [
            { 'title': 'VNIC#', 'data': 'index', 'width': '10%' },
            { 'title': 'Name', 'data': 'name', 'width': '20%' },
            { 'title': 'Type', 'data': 'type', 'width': '20%'},
            { 'title': 'IP Address', 'data': 'addressGroups', 'width': '20%'},
            { 'title': 'Connected To', 'data': 'name', 'width': '30%' }
        ],
        columnDefs: [
            {
                'targets': [0] ,
                'mRender': function (data, type, row) {
                    if (row.isNew  && typeof row.parentInterfaceIndex !== "undefined") {
                        return "*";
                    }
                    if (typeof row.index !== "undefined") {
                        return row.index;
                    }
                    
                }
            },
            {
                'targets': [2] ,
                'mRender': function (data, type, row) {
                    if (row) {
                        if (typeof row.parentInterfaceIndex !== "undefined" && typeof row.tunnelId !== "undefined") {
                            return "SubInterface";
                        }
                        if(row.type === 'uplink'){
                            return 'Uplink';
                        } else if (row.type === 'internal') {
                            return 'Internal';
                        } else {
                            return 'Trunk'
                        }
                    }
                    return '';
                }
            },
            {
                'targets': [3] ,
                'mRender': function (data, type, row) {
                    if (data) {
                        let displayString: string = '';
                        let edgeInterface: EdgeInterfaceDto = row as EdgeInterfaceDto;
                        let addressGroups = edgeInterface.addressGroups;
                        for ( let index: number = 0; index < addressGroups.length ; ++index) {
                            if (index !== 0) {
                                displayString += '<br>';
                            }
                            let addressGroup: IPAssignemntDto = addressGroups[index];
                            displayString += addressGroup.primaryAddress + '/' + addressGroup.subnetPrefixLength;
                        }
                        return displayString;
                    }
                    return '';
                }
            },
            {
                'targets': [4],
                'mRender': function (data, type, row) {
                    if (data) {
                        if(row.isConnected){
                            return data;
                        } else {
                            return 'Not Connected';
                        }
                    }
                    return '';
                }
            }
        ],
        'autoWidth': false,
        'oLanguage': {
            'sSearch': '',
            'sEmptyTable': 'Click on ADD button to start adding interfaces',
            'sInfoEmpty': ''
        },
        'scrollY': '100vh',
        'scrollCollapse': true,
        'paging': false,
        'bFilter': true,
        'bDestroy': true,
        'bUseRendered': false,
        "bSort": false,
        'rowCallback': function (row, data) {
        }
    };
}




// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/dialogs/wizard-steps/gateway-interface-configuration.dt.config.ts